module.exports = __webpack_public_path__ + "img/grid.b4cc803a.svg";